<template>
  <div class="tabbar">
    <Tabbar route fixed active-color="#ee0a24">
      <TabbarItem replace to="/"
        ><template #icon="props">
          <img :src="props.active ? icon.shouyered : icon.shouye" /> </template
        >首页</TabbarItem
      >
      <TabbarItem replace to="/store" v-if="distributionFlag"
        ><template #icon="props">
          <img :src="props.active ? icon.dianpured : icon.dianpu" /> </template
        >店铺</TabbarItem
      >
      <TabbarItem replace to="/discovery" v-if="distributionFlag"
        ><template #icon="props">
          <div
            class="flex flex-col justify-center"
            @click="clickDiscovery($event, props.active)"
          >
            <img class="mt-1 -mb-1" v-if="!props.active" :src="icon.faxian" />

            <img
              v-else
              style="
                height: 37px;
                padding-top: 5px;
                padding-left: 5px;
                padding-right: 5px;
                background-color: white;
                margin-top: -17px;
                border-radius: 50%;
              "
              :src="icon.faxianredbig"
            />

            <span class="text-xs mt-2">{{
              props.active ? "添加发现" : "发现"
            }}</span>
          </div>
        </template>
      </TabbarItem>

      <!-- 客户端才有导航客服 -->
      <TabbarItem @click="qiyuOpen" v-if="!distributionFlag"
        ><template #icon> <img :src="icon.customerService" /> </template
        >客服</TabbarItem
      >
      <TabbarItem replace to="/cart"
        ><template #icon="props">
          <img
            :src="props.active ? icon.gouwuchered : icon.gouwuche"
          /> </template
        >购物车</TabbarItem
      >
      <TabbarItem replace to="/mine"
        ><template #icon="props">
          <img :src="props.active ? icon.wodered : icon.wode" /> </template
        >我的</TabbarItem
      >
    </Tabbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Tabbar, TabbarItem } from "vant";
import { isWechatMP } from "@/utils/qiyukf";
import { getToken } from "@/utils/auth";
export default {
  components: { Tabbar, TabbarItem },
  data() {
    return {
      icon: {
        shouye: require("@/assets/tabbar/shouye.svg"),
        shouyered: require("@/assets/tabbar/shouyered.svg"),
        dianpu: require("@/assets/tabbar/dianpu.svg"),
        dianpured: require("@/assets/tabbar/dianpured.svg"),
        faxian: require("@/assets/tabbar/faxian.svg"),
        faxianredbig: require("@/assets/tabbar/faxianredbig.svg"),
        customerService: require("@/assets/tabbar/customerService.svg"),
        gouwuche: require("@/assets/tabbar/gouwuche.svg"),
        gouwuchered: require("@/assets/tabbar/gouwuchered.svg"),
        wode: require("@/assets/tabbar/wode.svg"),
        wodered: require("@/assets/tabbar/wodered.svg"),
      },
    };
  },
  computed: {
    ...mapGetters(["distributionFlag"]),
  },
  methods: {
    clickDiscovery(e, active) {
      if (active) {
        this.$emit("addDiscovery");
        e.stopPropagation();
      }
    },

    // 打开客服
    qiyuOpen() {
      if (!isWechatMP()) {
        ysf("onready", function () {
          ysf("open");
        });
      } else {
        const customerId = this.$store.state.user.customerId;
        const token = getToken();
        const Authorization = "Bearer " + token;
        this.wxjs.miniProgram.navigateTo({
          url: `/pages/kf/kf?customerId=${customerId}&Authorization=${Authorization}`,
          success: function (res) {
            console.log("kfres success", res);
          },
          fail: function (res) {
            console.log("kfres fail", res);
          },
          events: {
            acceptDataFromOpenedPage: function (data) {
              console.log("kf", data);
            },
          },
          complete: function (res) {
            console.log("kfres complete", res);
          },
        });
      }
    },
  },
};
</script>

<style>
.tabbar .van-tabbar--fixed::after {
  border-top: none;
}
</style>